<template>
  <router-link :to="href" class="c-text__link">{{text}}</router-link>
</template>

<script>
export default {
  props: {
    href: String,
    text: String
  }
}
</script>

<style lang="scss" scoped>
.c-text {

  &__link {
    &:not(:first-child){
      margin-left: 10px;
      @include media-queries-sp {
       margin-left: 0;
       margin-top: 10px;
      }
    }
  }
}
</style>
